import PropTypes from 'prop-types';
import { Icon, Tabs, TabList, Tab } from '@bwoty-web/ui-kit';

import { sectionIcons, sectionKeys } from '../sections/helper';

import './navigation.scss';

const Navigation = ({
  sections,
  selectedSectionKey,
  changeSection,
  labels,
  isGlobe,
}) => {
  const overviewSection = {
    key: sectionKeys.overview,
    name: labels.overviewHeading,
    icon: { default: sectionIcons.overview },
  };
  const mappedSections = sections.map((section) => {
    const { key, heading } = section;
    return {
      key,
      name: heading,
      icon: { default: sectionIcons[key] },
    };
  });

  const navigationSections = [overviewSection, ...mappedSections];

  const selectedSectionKeyBase = selectedSectionKey.split(':')[0];

  const sectionIndex = navigationSections.findIndex(
    (section) => section.key === selectedSectionKeyBase,
  );

  return (
    <nav className="gw-hotel-info-navigation">
      <Tabs
        defaultIndex={sectionIndex}
        selectedIndex={sectionIndex}
        onChange={(ix) => changeSection(navigationSections[ix].key)}
      >
        <TabList fullWidth>
          {navigationSections.map((item) => (
            <Tab key={item.key} lowercased={!isGlobe}>
              <div className="gw-hotel-info-navigation__tab-item">
                {!isGlobe && <Icon path={item.icon} alt="" />}
                <span>{item.name}</span>
              </div>
            </Tab>
          ))}
        </TabList>
      </Tabs>
    </nav>
  );
};

Navigation.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      key: PropTypes.string,
    }),
  ).isRequired,
  selectedSectionKey: PropTypes.string.isRequired,
  changeSection: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    overviewHeading: PropTypes.string,
    descriptionHeading: PropTypes.string,
  }).isRequired,
  isGlobe: PropTypes.bool,
};

Navigation.defaultProps = {
  isGlobe: false,
};

export default Navigation;
